import { render, staticRenderFns } from "./AddPercentageDialog.vue?vue&type=template&id=f3d89e4a&scoped=true"
import script from "@/components/add-percentage-dialog/AddPercentageDialog.ts?vue&type=script&lang=ts&external"
export * from "@/components/add-percentage-dialog/AddPercentageDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/add-percentage-dialog/add-percentage-dialog.scss?vue&type=style&index=0&id=f3d89e4a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d89e4a",
  null
  
)

export default component.exports